import { type FC } from "react";

import chaseIcon from "@/shared/assets/account_logos/chase.svg";
import bofaIcon from "@/shared/assets/account_logos/text_logos/bank_of_america.svg";
import fidelityIcon from "@/shared/assets/account_logos/fidelity.svg";
import wellsFargoIcon from "@/shared/assets/account_logos/wells-fargo.svg";

const LOGOS = [
  { name: "Chase", src: chaseIcon },
  { name: "Bank of America", src: bofaIcon },
  { name: "Fidelity", src: fidelityIcon },
  { name: "Wells Fargo", src: wellsFargoIcon },
];

interface InstitutionLogosProps {
  label?: string;
}

export const InstitutionLogos: FC<InstitutionLogosProps> = ({ label = "+12,000 institutions" }) => (
  <div className="flex items-center">
    <div className="flex -space-x-1.5">
      {LOGOS.map((inst) => (
        <div
          key={inst.name}
          className="flex h-6 w-6 shrink-0 items-center justify-center overflow-hidden rounded-full border-2 border-white bg-white"
        >
          <img src={inst.src} alt={inst.name} className="h-5 w-5 object-contain" />
        </div>
      ))}
    </div>
    <p className="ml-2 text-2xs text-tertiary">{label}</p>
  </div>
);
